const show = ({ user, stageId }) => {
  /**
   * current step
   */
  const current = document.querySelector(
    '[data-step-item][aria-hidden="false"]'
  )
  current.setAttribute('aria-hidden', 'true')
  current.dispatchEvent(
    new CustomEvent('step-on-hidden', {
      bubbles: true,
      cancelable: true
    })
  )

  /**
   * when the spare tire is not informed
   * return to the first step
   */
  let next =
    typeof stageId === 'string' ? document.querySelector(stageId) : stageId

  if (!next) next = getFirstStep()

  /**
   * next step
   */
  next.dispatchEvent(
    new CustomEvent('step-on-show', {
      bubbles: true,
      cancelable: true,
      detail: {
        user
      }
    })
  )
  next.setAttribute('aria-hidden', 'false')
}

const getFirstStep = () => {
  const steps = document.querySelectorAll('[data-step-item]')
  if (!steps[0]) console.warn('no steps with [data-step-item] found')
  return steps[0]
}

export default { show }
